import type {
	StripeCardElement,
	StripeCardElementChangeEvent,
} from '@stripe/stripe-js'
import { CardElement, useElements } from '@stripe/react-stripe-js'

const style = {
	base: {
		':-webkit-autofill': {
			color: '#6c757d',
		},

		'::placeholder': {
			color: '#6c757d',
		},
		color: '#494949',
		fontFamily: 'Nunito, sans-serif',
		fontSize: '14px',
		fontSmoothing: 'antialiased',
		fontWeight: 300,
	},
	invalid: {
		'::placeholder': {
			color: '#6c757d',
		},
		color: '#E25950',
	},
}

export const StripeCardInput = ({
	onChange,
	onError,
}: {
	onChange: (card: StripeCardElement) => void
	onError: (err?: string) => void
}) => {
	const elements = useElements()

	const handleChange = ({
		empty,
		complete,
		error,
	}: StripeCardElementChangeEvent) => {
		const element = elements?.getElement(CardElement)

		if (!element) return

		console.log({ complete, empty, error })

		onChange(element)

		if (error?.message || !complete) {
			onError(error?.message || 'errors:forms.cardIncomplete')
		} else {
			onError(undefined)
		}
	}

	return (
		<CardElement
			className='h-[40px] rounded-lg border px-4 pt-[11px]'
			onChange={handleChange}
			options={{ style }}
		/>
	)
}
